import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import "./ArtistRegister.css";

import "../../styles/font.css";
import { TopMenuEmpty } from '../../component/TopMenuEmpty';
import { API_CONFIG } from '../../config/api';

const artlog_ip = process.env.REACT_APP_ARTLOG_IP;

export const ArtistRegister = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  const [isArtlogConnect, setIsArtlogConnect] = useState(false);
  const [artlogToken, setArtlogToken] = useState(null);
  const [artlogLoginId, setArtlogLoginId] = useState("");
  const [artlogLoginPw, setArtlogLoginPw] = useState("");

  const [loginId, setLoginId] = useState("");
  const [loginPw, setLoginPw] = useState("");
  const [loginPwConfirm, setLoginPwConfirm] = useState("");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");


  const [interests, setInterests] = useState({
    westernPainting: false,
    koreanPainting: false,
    folkPainting: false,
    waterPainting: false,
    printPainting: false,
    sculpture: false,
    caligraphy: false,
    craft: false,
    picture: false,
    illustration: false
  });

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    const loadKakaoScript = async () => {
      // 우편번호 스크립트 로드
      const postScript = document.createElement("script");
      postScript.src = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
      document.head.appendChild(postScript);

      // Kakao 맵 스크립트 로드
      return new Promise((resolve) => {
        const mapScript = document.createElement("script");
        mapScript.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=cdabbe0b4373d904f58d672d596b6630&libraries=services&autoload=false";
        mapScript.async = true;
        
        mapScript.onload = () => {
          window.kakao.maps.load(() => {
            console.log("Kakao maps loaded with services");
            resolve();
          });
        };
        document.head.appendChild(mapScript);
      });
    };

    loadKakaoScript();
  }, []);

  const handleAddressSearch = () => {

    new window.daum.Postcode({
      oncomplete: function(data) {
        const addr = data.address;
        setAddress(addr);
        
        const geocoder = new window.kakao.maps.services.Geocoder();
        geocoder.addressSearch(addr, function(result, status) {
          if (status === window.kakao.maps.services.Status.OK) {
            setLat(result[0].y);
            setLng(result[0].x);
          } else {
            alert("주소를 좌표로 변환하는데 실패했습니다. 다시 시도해주세요.");
          }
        });
      }
    }).open();
  };

  const handleRegister = async () => {
    try {
      const formattedInterests = Object.fromEntries(
        Object.entries(interests).map(([key, value]) => [key, value ? 1 : 0])
      );

      const response = await fetch(`${API_CONFIG.MAIN}/tour_artist_register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          artist_login_id: loginId,
          artlog_token: artlogToken,
          artist_login_pw: loginPw,
          artist_name: name,
          artist_company: company,
          artist_email: email,
          artist_phone: phone,
          artist_description: description,
          artist_address: address,
          artist_lat: lat,
          artist_lng: lng,
          artist_website: website,
          ...formattedInterests
        }),
      });

      if (response.ok) {
        alert("작가 회원가입이 완료되었습니다.");
        navigate('/login');
      } else {
        const errorData = await response.json();
        alert(errorData.message || "회원가입에 실패하였습니다.");
      }
    } catch (error) {
      console.error("회원가입 요청 중 에러 발생:", error);
      alert("서버 오류가 발생했습니다.");
    }
  };

  const toggleInterest = (interest) => {
    setInterests(prevState => ({
      ...prevState,
      [interest]: !prevState[interest]
    }));
  };

  const isRegistrationValid = () => {
    return (
      loginId && 
      loginPw && 
      loginPwConfirm &&
      loginPw === loginPwConfirm &&
      name &&
      company &&
      email &&
      phone &&
      description &&
      address &&
      lat !== null &&
      lng !== null &&
      website
    );
  };

  const connectArtlog = async () => {
    try {
      const response = await fetch(`${artlog_ip}:3541/api/connect_artlog`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login_id: artlogLoginId,
          login_pw: artlogLoginPw,
        }),
      });
  
      if (response.ok) {
        const data = await response.json();
        alert('아트로그 연동이 완료되었습니다.');
        setArtlogToken(data.auth_token);
        setStep(step + 1);
      } else {
        const errorData = await response.json();
        alert(errorData.error || '아트로그 연동에 실패하였습니다.');
      }
    } catch (error) {
      console.error('아트로그 연동 중 에러 발생:', error);
      alert('서버 오류가 발생했습니다.');
    }
  };

  const goToNextStep = () => {
    setStep(step + 1);
  };

  const gotoMain = () => {
    navigate('/');
  }

  return (
    <div className="artist-register">
      <TopMenuEmpty />
      
      {step === 1 && (
        <div className="register-area">
          <div className="register-area__intro-title">작가 회원가입</div>
          <div className="register-area__intro-description">아트로그 계정 연동 여부를 선택해주세요</div>
          
          <div className="register-area__btn-area">
            <div className="register-area__btn-connect" onClick={() => {
              setStep(2);
              setIsArtlogConnect(true);
            }}>
              아트로그 계정으로 가입하기
            </div>

            <div className="register-area__btn-skip" onClick={() => {
              setStep(3);
              setIsArtlogConnect(false);
            }}>
              아트로그 연동 없이 가입하기
            </div>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="register-area">
          <div className="register-area__form">
            <div className="register-area__intro-description">
              아트로그 계정이 있다면 연동할 수 있습니다. (선택사항)
            </div>
            <input 
              type="text" 
              placeholder="아트로그 아이디" 
              value={artlogLoginId}
              onChange={(e) => setArtlogLoginId(e.target.value)}
            />
            <input 
              type="password" 
              placeholder="아트로그 비밀번호" 
              value={artlogLoginPw}
              onChange={(e) => setArtlogLoginPw(e.target.value)}
            />
            <div className="register-area__button-group">
              <button onClick={goToNextStep} className="skip-button">건너뛰기</button>
              <button onClick={connectArtlog} className="connect-button">연동하기</button>
            </div>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="register-area">
          <div className="register-area__form">
            <input
              className="register-area__input"
              type="text" 
              placeholder="아이디 (6~20자 영문, 숫자)" 
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
            />
            <input
              className="register-area__input"
              type="password" 
              placeholder="비밀번호 (8~12자 영문, 숫자, 특수문자)" 
              value={loginPw}
              onChange={(e) => setLoginPw(e.target.value)}
            />
            <input
              className="register-area__input"
              type="password" 
              placeholder="비밀번호 확인 (8~12자 영문, 숫자, 특수문자)" 
              value={loginPwConfirm}
              onChange={(e) => setLoginPwConfirm(e.target.value)}
            />
            <input
              className="register-area__input"
              type="text" 
              placeholder="작가명" 
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className="register-area__input"
              type="text" 
              placeholder="소속" 
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
            <input
              className="register-area__input"
              type="email" 
              placeholder="이메일" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="register-area__input"
              type="tel" 
              placeholder="연락처" 
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <textarea
              className="register-area__textarea"
              placeholder="작가 소개" 
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <div className="register-area__address-input-area">
              <input 
                className="register-area__address-input" 
                type="text" 
                placeholder="주소" 
                value={address}
                readOnly={true}
                onClick={handleAddressSearch}
              />
              <div className="register-area__address-input-btn" onClick={handleAddressSearch}>
                주소 검색
              </div>
            </div>
            <input
              className="register-area__input"
              type="text" 
              placeholder="웹사이트" 
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />

            <div className="register-area__interests">
              <div className="register-area__interests-title">전문 분야</div>
              <div className="register-area__interest-buttons">
                <div className={`register-area__interest-btn-block${interests.westernPainting ? "--selected" : ""}`} onClick={() => toggleInterest("westernPainting")}>
                  <div className={`register-area__interest-btn-text${interests.westernPainting ? "--selected" : ""}`}>서양화</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.koreanPainting ? "--selected" : ""}`} onClick={() => toggleInterest("koreanPainting")}>
                  <div className={`register-area__interest-btn-text${interests.koreanPainting ? "--selected" : ""}`}>한국화</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.folkPainting ? "--selected" : ""}`} onClick={() => toggleInterest("folkPainting")}>
                  <div className={`register-area__interest-btn-text${interests.folkPainting ? "--selected" : ""}`}>민화</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.waterPainting ? "--selected" : ""}`} onClick={() => toggleInterest("waterPainting")}>
                  <div className={`register-area__interest-btn-text${interests.waterPainting ? "--selected" : ""}`}>수채화</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.printPainting ? "--selected" : ""}`} onClick={() => toggleInterest("printPainting")}>
                  <div className={`register-area__interest-btn-text${interests.printPainting ? "--selected" : ""}`}>판화</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.sculpture ? "--selected" : ""}`} onClick={() => toggleInterest("sculpture")}>
                  <div className={`register-area__interest-btn-text${interests.sculpture ? "--selected" : ""}`}>조각</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.caligraphy ? "--selected" : ""}`} onClick={() => toggleInterest("caligraphy")}>
                  <div className={`register-area__interest-btn-text${interests.caligraphy ? "--selected" : ""}`}>서예</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.craft ? "--selected" : ""}`} onClick={() => toggleInterest("craft")}>
                  <div className={`register-area__interest-btn-text${interests.craft ? "--selected" : ""}`}>공예</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.picture ? "--selected" : ""}`} onClick={() => toggleInterest("picture")}>
                  <div className={`register-area__interest-btn-text${interests.picture ? "--selected" : ""}`}>사진</div>
                </div>
                <div className={`register-area__interest-btn-block${interests.illustration ? "--selected" : ""}`} onClick={() => toggleInterest("illustration")}>
                  <div className={`register-area__interest-btn-text${interests.illustration ? "--selected" : ""}`}>일러스트</div>
                </div>
              </div>
            </div>

            <div className={`register-area__register-button${isRegistrationValid() ? '--active' : '--inactive'}`}
              onClick={() => {
                if (isRegistrationValid()) {
                  handleRegister();
                } else {
                  alert('모든 필수 정보를 입력해주세요.');
                }
              }}>
              가입완료
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
